var _defs, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoadFPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 346.61,
    height: 468.84,
    viewBox: "0 0 346.61 468.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #414042;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 5px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #020202;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.5,
    x2: 2.5,
    y2: 468.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121,16.59V194.67a544.64,544.64,0,0,1,102.41-94.42A591.82,591.82,0,0,1,359.07,28.54",
    transform: "translate(-13.43 -10.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121,479.38c-1-33.2,1.18-125.82,70.21-217.56,58.08-77.18,133.37-113.71,167.86-128.1",
    transform: "translate(-13.43 -10.62)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37,29.35V13.43a.71.71,0,0,1,.62-.79.72.72,0,0,1,.79.62V29.35a.72.72,0,0,1-.63.79.7.7,0,0,1-.78-.62A.49.49,0,0,1,37,29.35Z",
    transform: "translate(-13.43 -10.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.17,30,30.28,23.1a.7.7,0,0,1,0-1,.72.72,0,0,1,1,0l6.39,6.39L44,22.11a.72.72,0,0,1,1,0,.85.85,0,0,1,.2.5.74.74,0,0,1-.2.49L38.12,30A.72.72,0,0,1,37.17,30Z",
    transform: "translate(-13.43 -10.62)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.81,462.67v15.92a.71.71,0,0,0,.62.79.72.72,0,0,0,.79-.62.48.48,0,0,0,0-.17V462.67a.72.72,0,0,0-.62-.79.7.7,0,0,0-.79.62A.49.49,0,0,0,98.81,462.67Z",
    transform: "translate(-13.43 -10.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99,462l-6.89,6.89a.7.7,0,0,0,0,1,.72.72,0,0,0,1,0l6.39-6.39,6.34,6.38a.72.72,0,0,0,1,0,.74.74,0,0,0,.2-.5.7.7,0,0,0-.2-.49L100,462A.72.72,0,0,0,99,462Z",
    transform: "translate(-13.43 -10.62)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M169.48,215.12l-12.2,10.23a.7.7,0,0,0-.2,1,.71.71,0,0,0,1,.21.69.69,0,0,0,.13-.11l12.19-10.23a.72.72,0,0,0,.21-1,.71.71,0,0,0-1-.2A.69.69,0,0,0,169.48,215.12Z",
    transform: "translate(-13.43 -10.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M170.1,214.87l-9.7-.85a.71.71,0,0,0-.77.64.72.72,0,0,0,.64.77l9,.78-.81,9a.73.73,0,0,0,.64.77.76.76,0,0,0,.52-.17.68.68,0,0,0,.24-.47l.85-9.71A.7.7,0,0,0,170.1,214.87Z",
    transform: "translate(-13.43 -10.62)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadFPhoto);
export default __webpack_public_path__ + "static/media/road-F-photo.1979071959f7f4462e451603ed2a6c0f.svg";
export { ForwardRef as ReactComponent };